import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ArrowDropDown';
import { useState } from 'react';
const Accordion = withStyles(theme => ({
    root: {
        borderRadius: 30,
        background: '#ececec',
        '&:before': {
            content: 'unset'
        }
    },
    expanded: {
        borderBottomLeftRadius: 30,
        borderBottomRightRadius: 30
    }
}))(MuiAccordion);

const AccordionSummary = withStyles(theme => ({
    root: {
        borderRadius: 30,

        backgroundColor: '#e0e0e0',

        marginBottom: -1,
        minHeight: 56,
        '&$expanded': {
            minHeight: 56
        },
        '&:first-child': {
            marginTop: 0
        }
    },
    content: {
        '&$expanded': {
            margin: '12px 0'
        }
    }
}))(MuiAccordionSummary);

const AccordionDetails = withStyles(theme => ({
    root: {
        borderRadius: 30,
        minHeight: 56,
        expanded: { borderTopLeftRadius: 0, borderTopRightRadius: 0 },
        padding: theme.spacing(2),
        background: '#ececec'
    }
}))(MuiAccordionDetails);

const EtiquetaResumen = ({ titulo, detalle, expanded, showIconDetail }) => (
    <Accordion square elevation={0} expanded={expanded}>
        <AccordionSummary expandIcon={showIconDetail ? <ExpandMoreIcon /> : null}>{titulo}</AccordionSummary>
        <AccordionDetails>
            <Typography>{detalle}</Typography>
        </AccordionDetails>
    </Accordion>
);

EtiquetaResumen.prototype = {
    titulo: PropTypes.node.isRequired,
    detalle: PropTypes.node,
    showIconDetail: PropTypes.bool,
    expanded: PropTypes.bool
};
EtiquetaResumen.defaultProps = {
    showIconDetail: true,
    detalle: null
};
export default EtiquetaResumen;
